import {Field} from '../types/Field';
import {ReloadWidget} from '../widgets/ReloadWidget';
import {widgetProps} from '../widgets/common';
import {Actions} from '../types/Action';

type Props = {
  field: Field;
  actions: Actions;
};

export function ReloadField(props: Props): JSX.Element | null {
  const interval = widgetProps<number | undefined>(
    props.field,
    'interval_seconds',
    undefined,
  );

  const action = props.actions.reload_or_throw;

  return <ReloadWidget intervalSeconds={interval} action={action} />;
}
